import { render, staticRenderFns } from "./otherDetail.vue?vue&type=template&id=37e32728&"
import script from "./otherDetail.vue?vue&type=script&lang=js&"
export * from "./otherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports